// Placement carries no source identity or quoted content. The API's quote DTO
// remains the sole authority for visibility, author, text and attachments.
export const QUOTE_ATTRIBUTE = 'data-wiw-quote';
export const QUOTE_HTML = '<div data-wiw-quote="true"></div>';

export function quotePlacementHTML(html, present) {
  const root = document.createElement('div');
  root.innerHTML = html || (present ? '<p></p>' : '');
  const markers = Array.from(root.querySelectorAll(`[${QUOTE_ATTRIBUTE}]`));
  markers.forEach((node, index) => {
    if (!present || index > 0) node.remove();
  });
  if (present && !markers.length) root.insertAdjacentHTML('beforeend', `${QUOTE_HTML}<p></p>`);
  return root.innerHTML;
}

export const hasQuotePlacement = doc => {
  let found = false;
  doc?.descendants(node => { if (node.type.name === 'reactionQuote') found = true; });
  return found;
};
